import HTTPClient from './http-client';
import { createUrl } from "../utils_functions";
const END_POINT = '/sensorstation';

const options = {
  cache: {
      maxAge: 15 * 60 * 1000,
      exclude: { query: false }
  }
}

const loadSensorStations = async ({organization_ids, sensor_ids, station_ids, stationtypes_ids}) => {
  const httpClient = new HTTPClient();
  const api = await httpClient.configure();
  const url = createUrl(END_POINT, {organization_ids, sensor_ids, station_ids, stationtypes_ids});
  return api.get(url, options);
}

export {
  loadSensorStations,
}
